<template>
<div class="card-row card-row-show">
 <div class="card-row-col card-col wp30">
   {{wallet.transporter}}
 </div>

  <div class="card-row-col card-col wp10">
   {{wallet.amount}}
 </div>
</div>
</template>

<script>
export default {
  props: ['wallet'],
};
</script>

